export default "__VITE_ASSET__B2CB3o3o__"